// libs
import { connect } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import isEmpty from 'lodash/isEmpty';

// selectors
import { getSSRHeaders, getWebAppType } from 'shared/store/app/selectors';
import {
  isFetching,
  isFetchingError as _isFetchingError,
  isNotFound as _isNotFound,
  getCMSData,
} from 'shared/store/cms/selectors';

// store
import { fetchCMSPageData as _fetchCMSPageData } from 'shared/store/cms/services';
import {
  updateStatusCode as _updateStatusCode,
  setHeaderOptions as _setHeaderOptions,
} from 'shared/store/app/actions';

// defs
import { ICMSPageDispatchProps, ICMSPageProps } from 'shared/layouts/CMSPage/types';

// components
import CMSWrapper from './CMSWrapper';

const mapStateToProps = (state: any) => {
  return {
    cmsData: getCMSData(state),
    ssrHeaders: getSSRHeaders(state),
    isFetchingError: _isFetchingError(state),
    isFetching: isFetching(state),
    isNotFound: _isNotFound(state),
    webAppType: getWebAppType(state),
  };
};

const mapDispatchToProps = {
  fetchCMSPageData: _fetchCMSPageData,
  updateStatusCode: _updateStatusCode,
  setHeaderOptions: _setHeaderOptions,
};

const fetchData = async ({
  webAppType,
  cmsData,
  fetchCMSPageData,
  ssrHeaders,
  pageId,
  updateStatusCode,
  setHeaderOptions,
  isNotFound,
  isFetchingError,
  isMobile = true,
}: ICMSPageProps) => {
  if (isEmpty(cmsData.content) && isEmpty(cmsData.jsContent)) {
    // isFetchingError : if server/api is down
    // isNotFound :  if page/inventory is not found on cms
    if (__BROWSER__ && !isNotFound && !isFetchingError) {
      window.location.reload();
    }

    // if the server fails i.e. isFetchingError or isNotFound is true
    // this condition will stop the application from going into infinite loop
    if (__BROWSER__) {
      return Promise.resolve();
    }

    const headers = ssrHeaders;

    const fetchCMSData = fetchCMSPageData({ headers, pageId, isMobile, webAppType });
    const setHeaders = new Promise((resolve) => {
      setHeaderOptions({
        showDiscount: false,
        showHamburger: true,
        showLogo: true,
        showLogoOnLeft: true,
        headerMerge: false,
        showBack: false,
        showSearch: true,
        showCart: true,
        showBottomBorder: true,
      });
      resolve({});
    });

    return Promise.all([fetchCMSData, setHeaders]).catch((err: { status: number }) => {
      if (err.status === 404) {
        updateStatusCode(404);
      } else {
        updateStatusCode(500);
      }
    });
  }
};

export default connect<ICMSPageProps, ICMSPageDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(frontloadConnect(fetchData)(CMSWrapper));
